<template>
  <div class="editPage" v-loading="loading">
    <qx-card :title="pageTitle">
      <BaseForm ref="baseForm" />
    </qx-card>
    <SubBtnBox @sub="sub" v-if="!$route.query.type" />
  </div>
</template>

<script>
import BaseForm from './base';
import SubBtnBox from 'components/subBtnBox';
import {
  roleEdit,
  jurisdictionList,
  roleDetail,
} from 'api/system';
import pageDataMixin from '@qx/mixin/pageData';
export default {
  mixins: [
    pageDataMixin,
  ],
  components: {
    BaseForm,
    SubBtnBox,
  },
  data () {
    return {
      loading: false,
      pageUrl: '/manage/system/jurisdiction/jurisdiction/edit',
      formComponents: ['baseForm'],
      isEdit: true,
    };
  },
  computed: {
    detailParams () {
      return {
        roleId: this.$route.query.id,
      };
    },
  },
  methods: {
    async detailApi () {
      this.loading = true;
      let roleDetailRes = {};
      if (this.$route.query.id) {
        roleDetailRes = await roleDetail({
          roleId: this.$route.query.id,
        });
      }
      const jurisdictionRes = await jurisdictionList({
        roleId: this.$route.query.id,
        doMain: 'vue',
      });
      this.loading = false;
      return {
        roleName: roleDetailRes.roleName,
        btnMenu: jurisdictionRes.sysMenu1.childMenus,
        dataMenu: jurisdictionRes.sysMenu2.childMenus,
        baseDataMenu: jurisdictionRes.sysMenu3.childMenus,
      };
    },
    editApi: roleEdit,
  },
  async mounted () {
    this.getData();
  },
};
</script>

<style scoped lang="scss">
</style>
